function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import { FileInput } from '@leverege/ui-elements';
export default class CodeInput extends React.Component {
  static propTypes = {
    eventData: PropTypes.any,
    onChange: PropTypes.func,
    onError: PropTypes.func,
    zxOpts: PropTypes.object
  };
  static defaultProps = {
    eventData: undefined,
    onChange: () => {},
    onError: () => {},
    zxOpts: undefined
  };
  onChange = async event => {
    const {
      onChange,
      onError,
      eventData,
      zxOpts
    } = this.props;
    const {
      value
    } = event;
    try {
      const {
        decodeFromImg
      } = await import('../actions/decode.js');
      const result = await decodeFromImg(value, {
        zxOpts
      });
      if (typeof onChange === 'function') {
        if (Array.isArray(result)) {
          const errors = [];
          const successes = [];
          result.forEach(resItem => {
            if (resItem instanceof Error) {
              errors.push(resItem);
            } else {
              successes.push(resItem);
            }
          });
          if (errors.length > 0) {
            onError({
              data: eventData,
              error: errors
            });
          }
          if (successes.length > 0) {
            onChange({
              data: eventData,
              value: successes,
              files: value
            });
          }
        } else {
          onChange({
            data: eventData,
            value: result,
            files: value
          });
        }
      }
    } catch (error) {
      if (typeof onError === 'function') {
        onError({
          data: eventData,
          error
        });
      }
    }
  };
  render() {
    const {
      children,
      onChange,
      eventData,
      fileTypes,
      zxOpts,
      ...rest
    } = this.props;
    return /*#__PURE__*/React.createElement(FileInput, _extends({
      onChange: this.onChange,
      fileTypes: fileTypes || 'image/*'
    }, rest), children);
  }
}